import { createHistory } from 'history';
import { useRouterHistory } from 'react-router';
import URI from 'urijs';

const createBrowserHistory = () => {
  return useRouterHistory(createHistory)({
    basename: URI.joinPaths(window.__BASE_PATH__, window.__CLIENT_BASE_PATH__).pathname() || '',
  });
};

export default createBrowserHistory;
